import React from "react";
import './Footer.css';
import {Link} from "react-router-dom"
import moment from "moment";
import btx_square from "../../images/logos/logo_btx_small.jpg";
import fortitude from "../../images/logos/4titude_france.png";
import PhoneNumber from "../shared/phoneNumber/PhoneNumber";
const version = require('../../../package.json').version;

export default class Footerr extends React.Component{

    constructor(props) {
        super(props);
        this.state={

        }
    }

    componentDidMount() {
      this.setState({ version });
    }
    render(){
        return (
            <div className={"footer-wrapper"}>

                <div className={"centerer-wrapper"}>
                    <div className={"centerer"}>
                        <div className={"footer-logos-wrapper"}>
                            <img alt={"Logo Bio-Technofix"} style={{height:60, marginRight:20, borderRadius:4}} src={btx_square}/>
                            <img alt={"Logo 4titude France"} style={{height:60, borderRadius:4}} src={fortitude}/>
                            <address className={"footer-address"}>
                                Bio-Technofix<br/>
                                5 rue Denis Papin, ZA de la Mare du Milieu – Lot C<br/>
                                91630 Guibeville, France
                            </address>
                        </div>

                        <div className={"footer-sitemap-wrapper"}>

                            {/*FIRST*/}
                            <div className={"footer-sitemap-column"}>
                                <span style={{color:"#EFEFEF", fontSize:16, textAlign:"left", marginBottom:15}}>
                                    Sur le site
                                </span>
                                <Link className={"footer-link"} to={"/home"}>
                                    <span style={{color:"#CCCCCC", fontSize:14, textAlign:"left", display:"inline-block", marginBottom:10}}>
                                        Accueil
                                    </span>
                                </Link>
                                <Link className={"footer-link"} to={"/my/account"}>
                                    <span style={{color:"#CCCCCC", fontSize:14, textAlign:"left", display:"inline-block", marginBottom:10}}>
                                        Espace client
                                    </span>
                                </Link>
                                <Link className={"footer-link"} to={"/cart"}>
                                    <span style={{color:"#CCCCCC", fontSize:14, textAlign:"left", display:"inline-block"}}>
                                        Ma demande de devis
                                    </span>
                                </Link>
                            </div>

                            {/*SECOND*/}
                            <div className={"footer-sitemap-column"}>
                                <span style={{color:"#EFEFEF", fontSize:16, textAlign:"left", marginBottom:15}}>
                                    Autour de Bio-Technofix
                                </span>
                                <Link className={"footer-link"} to={"/about"}>
                                    <span style={{color:"#CCCCCC", fontSize:14, textAlign:"left", display:"inline-block", marginBottom:10}}>
                                        Qui sommes-nous ?
                                    </span>
                                </Link>
                                <Link className={"footer-link"} to={"/terms"}>
                                    <span style={{color:"#CCCCCC", fontSize:14, textAlign:"left", display:"inline-block", marginBottom:10}}>
                                        Conditions de vente
                                    </span>
                                </Link>
                                <Link className={"footer-link"} to={"/mentions-legales"}>
                                    <span style={{color:"#CCCCCC", fontSize:14, textAlign:"left", display:"inline-block", marginBottom:10}}>
                                        Mentions légales
                                    </span>
                                </Link>
                                <button
                                    type={"button"}
                                    className={"footer-link footer-cookie-link"}
                                    onClick={() => window.dispatchEvent(new Event("openCookieConsent"))}
                                >
                                    Gérer les cookies
                                </button>
                            </div>

                            {/*LAST*/}
                            <div className={"footer-sitemap-column"}>
                                <span style={{color:"#EFEFEF", fontSize:16, textAlign:"left", marginBottom:15}}>
                                    Assistance
                                </span>
                                <Link className={"footer-link"} to={"/contact/us"}>
                                    <span style={{color:"#CCCCCC", fontSize:14, textAlign:"left", display:"inline-block", marginBottom:15}}>
                                        Contact
                                    </span>
                                </Link>

                                <PhoneNumber/>
                            </div>

                        </div>

                        <div className={"bottom"}>
                          <p className={"footer-copyright"}>Bio-Technofix {moment().format("YYYY")}. Tous droits réservés.</p>
                          <span className={"version-number"}>{version}</span>
                        </div>

                    </div>
                </div>


            </div>
        );
    }

}

